import { environment } from '../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ResultadosEleicao } from '../models/resultadosEleicao.model';

@Injectable({
  providedIn: 'root'
})
export class ResultadosService {
  configHeader: any;

  constructor(
    private http: HttpClient
    ) { }

  public getAllByIdEleicao(idEleicao: number, token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
        this.http.get<ResultadosEleicao>(`${environment.url_api}/eleicoes/${idEleicao}/resultado`, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          },
          (err) => {
            reject(err.error);
          }
        )
    })
  }
  public getAllParcialByIdEleicao(idEleicao: number, intervaloDatas: string[], token: any) {
    console.log(intervaloDatas);
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
        this.http.post<ResultadosEleicao>(`${environment.url_api}/eleicoes/${idEleicao}/resultadoParcial`, intervaloDatas, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          },
          (err) => {
            reject(err.error);
          }
        )
    })
  }
 
}
